<ion-header class="header-item">
  <ion-toolbar class="ion_tool_bar_css">
    <ion-buttons slot="start" class="mrglft5pt">
      <ion-icon name="arrow-back" class="icon_left" (click)="closeBtnClick()"></ion-icon>
    </ion-buttons>
    <span class="headerText">Select user</span>
  </ion-toolbar>
</ion-header>

<div class="add_contractor_div">
  <ion-row class="">
    <ion-col class="add_contractor_label">
      {{ "ADD_CONTRACTOR_COMPOENENT.ADD_USER" | translate }}
    </ion-col>
  </ion-row>

  <ion-row class="emp_type_row">
    <ion-radio-group [(ngModel)]="employee_type" (ionChange)="employeeTypeSelect($event, true)">
      <div class="radio-row">
        <ion-item lines="none">
          <ion-label>Employee</ion-label>
          <ion-radio mode="md" slot="start" value="Employee"></ion-radio>
        </ion-item>

        <ion-item lines="none">
          <ion-label>Contractor</ion-label>
          <ion-radio mode="md" slot="start" value="contractor"></ion-radio>
        </ion-item>
      </div>
    </ion-radio-group>
  </ion-row>

  <form [formGroup]="addContractorForm" class="formPadding">
    <ion-row *ngIf="employee_type == 'contractor'">
      <ion-col>
        <mat-form-field appearance="outline" class="formField">
          <mat-label>{{ "ADD_CONTRACTOR_COMPOENENT.SELECT_COMPANY" | translate }}
          </mat-label>
          <input type="text" matInput formControlName="Company_Name" [matAutocomplete]="auto" />
          <ion-icon matSuffix class="dropdown_icon" name="search-outline"></ion-icon>
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
            <mat-option *ngFor="let item of company_list" [value]="item.vendor_name">{{ item.vendor_name }}</mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="first_row_col">
        <mat-form-field appearance="outline" class="formField">
          <mat-label>{{
            "ADD_CONTRACTOR_COMPOENENT.FIRST_NAME" | translate
            }}</mat-label>
          <input matInput formControlName="First_Name" />
        </mat-form-field>
      </ion-col>
      <ion-col class="first_row_col">
        <mat-form-field appearance="outline" class="formField">
          <mat-label>{{
            "ADD_CONTRACTOR_COMPOENENT.LAST_NAME" | translate
            }}</mat-label>
          <input matInput formControlName="Last_Name" />
        </mat-form-field>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <mat-form-field appearance="outline" class="formField">
          <mat-label>{{
            "ADD_CONTRACTOR_COMPONENT.EMAIL" | translate
            }}</mat-label>
          <input matInput formControlName="Email" type="email" />
          <mat-error *ngIf="addContractorForm.get('Email').hasError('Email')">
            {{ "ADD_CONTRACTOR_COMPONENT.EMAIL_ERROR_MESSAGE" | translate }}
          </mat-error>
        </mat-form-field>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col class="phone_num_field_col">
        <form #f="ngForm" [formGroup]="phoneForm">
          <div class="phone_num_div">
            <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="preferredCountries"
              [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
              [searchCountryField]="[
                SearchCountryField.Iso2,
                SearchCountryField.Name
              ]" [selectFirstCountry]="false" [maxLength]="15" [phoneValidation]="true" [separateDialCode]="true"
              [numberFormat]="PhoneNumberFormat.National" name="phone" formControlName="phone">
            </ngx-intl-tel-input>
          </div>
        </form>
        <div *ngIf="validationtext!=''" class="error_ph_mesg">{{validationtext}}</div>
      </ion-col>
    </ion-row>
  </form>

  <ion-row class="add_contractor_btn_row">
    <ion-col>
      <div class="btn-container">
        <!-- Cancel = outlined -->
        <button mat-stroked-button color="primary" (click)="closePopup('cancel')" class="cancelBtn">
          Cancel
        </button>

        <!-- Add = filled -->
        <button mat-raised-button color="primary" (click)="addContractor(addContractorForm.value)"
          [disabled]="!addContractorForm.valid" class="saveBtn">
          {{ "ADD_CONTRACTOR_COMPONENT.ADD" | translate }}
        </button>
      </div>
    </ion-col>
  </ion-row>

</div>